import { Device, until } from '@helpers/media';
import useMedia from '@hooks/useMedia';
import { FakeButton } from '@stories/Components/Buttons/Button/Button';
import React from 'react';
import ReactPaginate from 'react-paginate';
import { PaginationStyles as S } from './Pagination.styles';
const Pagination = ({ currentPage, pageCount, onChange, disabled, translations, }) => {
    const isMobile = useMedia([`${until(Device.MobileLarge)}`], [true], false);
    return (React.createElement(S.Container, { "data-disabled": disabled },
        React.createElement(S.PageDisplay, null,
            "Page ",
            React.createElement("span", null, currentPage),
            " of ",
            React.createElement("span", null, pageCount)),
        React.createElement(S.PaginationControls, null,
            React.createElement(S.PageButton, { disabled: currentPage === 1 || disabled, onClick: () => onChange(currentPage - 1), "aria-label": translations?.['listings.previousPage'] ?? 'Previous Page' },
                React.createElement(FakeButton, { buttonType: "solid-white", iconOnly: true })),
            React.createElement(ReactPaginate, { pageCount: pageCount, forcePage: currentPage - 1, pageRangeDisplayed: isMobile ? 1 : 2, marginPagesDisplayed: 1, breakLabel: "...", onPageChange: (s) => onChange(s.selected + 1), className: "pagination" }),
            React.createElement(S.PageButton, { disabled: currentPage === pageCount || disabled, onClick: () => onChange(currentPage + 1), "aria-label": translations?.['listings.nextPage'] ?? 'Next Page' },
                React.createElement(FakeButton, { buttonType: "solid-white", iconOnly: true })))));
};
export default Pagination;
